import React, { FC, useState } from 'react'
import { useStore } from 'store'

// VR1
import OpenSection from './VR/OpenSection'
import UnveilSection from './VR/UnveilSection'
import ConnectSection from './VR/ConnectSection'
import KnowSection from './VR/KnowSection'
import ReserveSection from './VR/ReserveSection'

// V3.0
import VideoSection from './Somnium/VideoSection'
import WelcomeSection from './Somnium/WelcomeSection'
import DiscoverSection from './Somnium/DiscoverSection'
import ExploreSection from './Somnium/ExploreSection'
import BecomeSection from './Somnium/BecomeSection'
import UnitySection from './Somnium/UnitySection'
import PlayCanvasSection from './Somnium/PlayCanvasSection'
import SpecialSection from './Somnium/SpecialSection'
import BuildingSection from './Somnium/BuildingSection'
import RecognizedMediaSection from './Somnium/RecognizedMediaSection'
import ConnectWithUsSection from './Somnium/ConnectWithUsSection'

import { SiteVariant } from 'utils'

interface IProps {
}

const Main: FC<IProps> = () => {
  const { userStore } = useStore()
  const [siteVariant] = useState(userStore.siteVariant)

  return (
    <React.Fragment>
      {siteVariant === SiteVariant.VR
        ? <>
          <OpenSection/>
          <UnveilSection/>
          <ConnectSection/>
          <KnowSection/>
          <ReserveSection/>
        </>
        : <>
          <VideoSection/>
          <WelcomeSection/>
          <DiscoverSection/>
          <ExploreSection/>
          <BecomeSection/>
          <UnitySection/>
          <PlayCanvasSection/>
          <SpecialSection/>
          <BuildingSection/>
          <RecognizedMediaSection/>
          <ConnectWithUsSection/>
        </>
      }
    </React.Fragment>
  )
}

export default Main
